export default function () {
  // const primaryColor = '#111111'

  if (import.meta.client) {
    const appConfig = useAppConfig()
    const primaryColor = computed(() => getComputedStyle(document.documentElement).getPropertyValue(`--color-${appConfig.ui.colors.primary}-500`).trim())
    return primaryColor
  }
  else {
    return '#111111'
  }
}
